function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5 15c6 0 9.35-5.39 9.35-10.06v-.45A7 7 0 0016 2.66a6.06 6.06 0 01-1.89.55 3.55 3.55 0 001.45-1.95 6.48 6.48 0 01-2.09.85A3.19 3.19 0 0011.08 1a3.41 3.41 0 00-3.29 3.53 3.59 3.59 0 00.09.81 9.12 9.12 0 01-6.77-3.69 3.71 3.71 0 00-.44 1.77 3.61 3.61 0 001.46 2.94 3.12 3.12 0 01-1.48-.44V6a3.48 3.48 0 002.63 3.43 3 3 0 01-.86.12 3.18 3.18 0 01-.62-.06 3.31 3.31 0 003.06 2.45 6.28 6.28 0 01-4.08 1.51 5.11 5.11 0 01-.78 0A8.72 8.72 0 005 15z"
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.5fd63fcc.svg";
export { ForwardRef as ReactComponent };